import React, { useMemo } from "react";
import { Tiptap, useTiptapState } from "@tiptap/react";
import { WEBSITE_BUILDER_RICH_TEXT_CLASS_NAME } from "./websiteBuilderRichTextRenderer";
import { useSectionEntityPreviewContext } from "../../designSpace/views/components/sectionEntity/SectionEntityPreviewContext";
import { TWebsiteBuilderRichTextResponsiveFontSize, websiteBuilderGetRichTextResponsiveFontSizeStyles } from "../extensions/websiteBuilderRichTextResponsiveFontSize";

export function WebsiteBuilderRichTextEditorContent() {
  const { preview } = useSectionEntityPreviewContext();

  const responsiveFontSizeStyles = useTiptapState(({ editor }) => {
    const responsiveFontSize: TWebsiteBuilderRichTextResponsiveFontSize = editor.state.doc.attrs.responsiveFontSize;

    return websiteBuilderGetRichTextResponsiveFontSizeStyles(responsiveFontSize);
  });

  const previewAttributes = useMemo(() => {
    if (preview == null || preview.type !== "element" || preview.element.type !== "heading") {
      return {};
    } else {
      const { level } = preview.element;

      return {
        ...(level != null ? { "data-preview-heading-level": level } : {}),
      };
    }
  }, [preview]);

  return (
    <Tiptap.Content
      className={WEBSITE_BUILDER_RICH_TEXT_CLASS_NAME}
      style={responsiveFontSizeStyles}
      {...previewAttributes}
    />
  );
}
